// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"180":"video","303":"widget","495":"feed"}[chunkId] + "." + {"180":"86f1916538161273b8ab","303":"14f1c137f1a461c15ac3","495":"d3ac4c4d7ee13a15e161"}[chunkId] + ".js";
};